var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 10,
    fill: "#F24E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 14,
    r: 10,
    fill: "#FF7262"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 32,
    r: 10,
    fill: "#A259FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32,
    r: 10,
    fill: "#1ABCFE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 50,
    r: 10,
    fill: "#0ACF83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.915f4f4c1ab1cbdfbb1eaf97a954717a.svg";
export { ForwardRef as ReactComponent };